export default {
    showVariationsModal: {
        copy: 'Kopier',
        contentVariation: 'Innholdsvariasjon',
        chosenContent: 'Valgt innhold',
        chosenContentPlaceholder: 'Vennligst fyll inn',
        continue: 'Fortsett',
        generateNewContent: 'Generer nytt innhold',
        type: 'Type:',
        contentTitle: 'Tittel:',
        descriptionLabel: 'Beskrivelse:',
        keywordsLabel: 'Nøkkelord:',
        writingTone: 'Skrivestil:',
        context: 'Kontekst:',
        cancel: 'Avbryt',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
